import styled, { css } from 'styled-components'
import theme from '../../../styled/theme'
import fonts from '../../../styled/fonts'

const sizes = {
	tiny: css`
		display: flex;
		max-width: 8rem;
		justify-content: center;
		align-items: center;
		gap: 0.5rem;
		flex-shrink: 0;
		align-self: stretch;
		padding: 14px 14px 16px 10px;
	`,
	small: css`
		display: flex;
		min-width: 10.5rem;
		max-width: 12rem;
		justify-content: center;
		align-items: center;
		gap: 0.5rem;
		flex-shrink: 0;
		align-self: stretch;
		padding: 14px 14px 16px 10px;
	`,
	medium: css`
		display: flex;
		min-width: 232px;
		max-width: 16rem;
		justify-content: center;
		align-items: center;
		gap: 0.5rem;
		flex-shrink: 0;
		align-self: stretch;
		padding: 14px 14px 16px 10px;
	`,
	large: css`
		display: flex;
		max-width: 18rem;
		height: 40px;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		gap: 8px;
	`,
	xlarge: css`
		display: flex;
		width: 360px;
		height: 48px;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		gap: 8px;
	`,
	mobile: css`
		display: flex;
		width: 100%;
		height: 48px;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
	`,
	text: css`
		display: flex;
		width: 100%;
		height: 40px;
		justify-content: flex-start;
		align-items: center;
		flex-shrink: 0;
	`,
	card: css`
		display: flex;
		width: 100%;
		max-width: 100%;
		padding: 18px 16px;
		justify-content: space-between;
		align-items: center;
		flex-shrink: 0;
	`
}

const variants = {
	primary: css`
		background-color: ${theme.colors.brand.blueOmint};
		color: ${theme.colors.brand.white};
		&:hover {
			background-color: ${theme.colors.brand.blueDark};
		}
		&:disabled {
			color: ${theme.colors.text.secondaryText};
			background-color: ${theme.colors.greys.dividerGray};
		}
		&:focus {
			border: 2px solid ${theme.colors.brand.white};
		}
		&:active {
			border: none;
		}
	`,
	secondary: css`
		background-color: ${theme.colors.brand.white};
		color: ${theme.colors.brand.blueOmint};
		border: 1px solid ${theme.colors.brand.blueOmint};

		&:hover {
			background-color: ${theme.colors.brand.blueOmint};
			color: ${theme.colors.brand.white};
		}
		&:disabled {
			color: ${theme.colors.text.secondaryText};
			background-color: ${theme.colors.greys.dividerGray};
			border: 1px solid ${theme.colors.text.secondaryText};
		}
		&:focus {
			border: 3px solid ${theme.colors.brand.blueOmint};
		}
		&:active {
			border: none;
		}
	`,
	tertiary: css`
		background-color: ${theme.colors.brand.white};
		color: ${theme.colors.brand.blueOmint};
		display: inline-flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
		.button-label {
			text-decoration: ${({ $underline }) => ($underline ?? true ? 'underline' : 'none')};
		}
		align-self: flex-start;
		width: auto;
		margin-top: ${({ $mt }) => ($mt ? $mt : '15px')};
		padding: 0;
		&:hover {
			color: ${theme.colors.lightBlue};
			& > div > svg > path {
				stroke: ${theme.colors.lightBlue};
			}
		}
		&:disabled {
			color: ${theme.colors.text.secondaryText};
			background-color: transparent;
		}
		&:focus {
			${({ $showBorder = true }) =>
				$showBorder &&
				css`
					border: 2px solid ${theme.colors.brand.blueOmint};
				`}
		}
		&:active {
			border: none;
		}
	`,
	link: css`
		background-color: transparent;
		color: ${theme.colors.brand.blueOmint};
		display: inline-flex;
		flex-direction: row;
		align-items: center;
		gap: 5px;
		width: auto;
		height: auto;
		padding: 0;
		font-size: 14px;
		.button-label {
			text-decoration: none;
		}
		&:hover {
			.button-label {
				text-decoration: underline;
			}
		}
		&:disabled {
			color: ${theme.colors.text.secondaryText};
			background-color: transparent;
		}
	`,
	cardNav: css`
		background-color: ${theme.colors.brand.white};
		color: ${theme.colors.text.primaryText};
		border: 1px solid ${theme.colors.greys.dividerGray};
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		font-weight: 400;
		font-size: ${fonts.fontSizes.lg};
		&:hover {
			box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
			border-color: ${theme.colors.greys.mediumGray};
			background-color: ${theme.colors.greys.dividerGray};
		}

    &:hover {
      color: ${theme.colors.lightBlue};
      & > div > svg > path {
        stroke: ${theme.colors.lightBlue};
      }
    }
    &:disabled {
      color: ${theme.colors.text.secondaryText};
      background-color: ${theme.colors.brand.white};
    }
    &:focus {
      ${({ $showBorder = true }) =>
        $showBorder &&
        css`
          border: 2px solid ${theme.colors.brand.blueOmint};
        `}
    }
    &:active {
      border: none;
    }
  `,
  cardNav: css`
    background-color: ${theme.colors.brand.white};
    color: ${theme.colors.text.primaryText};
    border: 1px solid ${theme.colors.greys.dividerGray};
    font-weight: 400;
    font-size: ${fonts.fontSizes.md};
    &:hover {
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
      border-color: ${theme.colors.greys.mediumGray};
          background-color: ${theme.colors.greys.dividerGray};
    }

    &:disabled {
      color: ${theme.colors.text.secondaryText};
      background-color: ${theme.colors.greys.lightGray};
      border: 1px solid ${theme.colors.greys.dividerGray};
      cursor: not-allowed;
    }

  
  `,
}
export const StyledButton = styled.button.attrs(props => ({
	disabled: props.disabled
}))`
  font-family: 'Source Sans Pro', system-ui, Avenir, Helvetica, Arial,
    sans-serif;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex; 
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: ${fonts.fontSizes.md};
  align-self: ${({ alignSelf }) => alignSelf || 'initial'} !important;
  height: ${({ height }) => height || '40px' };
  min-width: auto;
  width: ${({ width }) => width || '100%'};
  max-width: 100%;   
  ${({ padding }) => padding && `padding: ${padding};`}

  ${({ size }) => size && sizes[size]}
  ${({ $variant }) => $variant && variants[$variant]}

  ${({ backgroundColor }) =>
		backgroundColor &&
		css`
			background-color: ${theme.colors.brand[backgroundColor] || theme.colors[backgroundColor]};
			color: ${backgroundColor === 'white'
				? theme.colors.brand.blueOmint
				: theme.colors.brand.white};
		`}

  ${({ hoverColor }) =>
		hoverColor &&
		css`
			&:hover {
				color: ${hoverColor === 'tertiary'
					? theme.colors.brand.blueOmint
					: theme.colors.brand.white};
				background-color: ${theme.colors.brand[hoverColor] || theme.colors[hoverColor]};
			}
		`}

  @media (max-width: ${({ theme }) => theme.sizes.breakPoints.small}) {
    width: ${({ $variant }) => ($variant === 'tertiary' || $variant === 'link' ? 'auto' : '100%')};
    max-width: ${({ $variant }) => ($variant === 'tertiary' || $variant === 'link' ? 'none' : '100%')};
    display: ${({ $variant }) => ($variant === 'tertiary' || $variant === 'link' ? 'flex' : 'inline-flex')};
    flex-direction: row;
    gap: 8px;

  }

  &:disabled {
    cursor: not-allowed;
    color: ${theme.colors.text.secondaryText} !important;
    ${({ $variant }) =>
			$variant === 'tertiary' || $variant === 'link'
				? css`
						background-color: transparent !important;
						border: none !important;
					`
				: css`
						background-color: ${theme.colors.greys.dividerGray} !important;
						border: 1px solid ${theme.colors.greys.dividerGray} !important;
					`}
  }
`
